import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2, Smile } from "lucide-react";
import { AGE_STAGES } from "@/data/teeth";

export const AgeGuide = ({ stage, setStage, mode }) => {
  const s = AGE_STAGES[stage];
  return (
    <div className="rounded-[2rem] border-2 border-slate-800/5 bg-white p-6 sm:p-8" data-testid="hero-age-guide">
      <p className="font-display text-xl font-semibold text-slate-800">{mode === "kids" ? "How old are you?" : "How old is your child?"}</p>
      <div className="mt-4 grid grid-cols-5 gap-2" role="tablist">
        {AGE_STAGES.map((a, i) => (
          <button key={a.label} onClick={() => setStage(i)} data-testid={`hero-age-${i}`} role="tab" aria-selected={i === stage}
            className={`rounded-2xl border-2 px-1 py-2.5 text-xs font-bold transition-colors sm:text-sm ${i === stage ? "border-slate-800 bg-[#f5b82e] text-slate-900" : "border-slate-200 bg-white text-slate-600 hover:border-teal-300"}`}>{a.label}</button>
        ))}
      </div>
      <AnimatePresence mode="wait">
        <motion.div key={`${stage}${mode}`} initial={{ opacity: 0, x: 16 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -16 }} className="mt-5">
          <div className="flex flex-wrap items-baseline justify-between gap-2">
            <p className="font-display text-2xl font-bold text-teal-700" data-testid="hero-age-title">{s.title}</p>
            <span className="rounded-full bg-[#e0f2fe] px-3 py-1 text-xs font-bold text-sky-800">{s.teeth}</span>
          </div>
          {mode === "kids" ? (
            <p className="mt-3 flex gap-2 text-base font-semibold text-slate-700"><Smile className="h-6 w-6 shrink-0 text-[#ff6b6b]" />{s.kid}</p>
          ) : (
            <ul className="mt-3 grid gap-2 sm:grid-cols-2">
              {s.tips.map((t) => <li key={t} className="flex gap-2 text-sm text-slate-600"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-teal-600" />{t}</li>)}
            </ul>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
